import React, { useEffect, useState } from 'react';
import Td from '@visa/vds/td';
import Tr from '@visa/vds/tr';
import Icon from '@visa/vds/icon';
import MCSPagedTable from '../../../components/MCSPagedTable';

import { SubscriptionApi } from '../../../services/subscription.service';

function BillingLineTable(props) {
    const [isLoaded, setIsLoaded] = useState(false);
    const [data, setData] = useState(null);

    let colHeaders = [
        { displayName: "Line Number", name: "lineNumber" },
        { displayName: "Description", name: "description" },
        { displayName: "Reference Manual Description", name: "customDescription" },
        { displayName: "Price (USD)", name: "price" },
        { displayName: "", name: "action", orderable: false }
    ];

    useEffect(() => {
        SubscriptionApi.GetBillingLines(props.productCategoryId)
            .then((response) => {
                setData(response);
                setIsLoaded(true);
                props.isLoaded(true);
            })
    }, []);


    return (
        <>
            { isLoaded &&
                <MCSPagedTable size={"compact"}
                    colHeaders={colHeaders}
                    useSearchBar={false}
                    usePagination={false}
                    tableData={
                        data && data.map((row, key) => (
                            <Tr key={key}>
                                <Td>{row.lineNumber}</Td>
                                <Td>{row.description}</Td>
                                <Td>{row.manualDescription}</Td>
                                <Td>{row.price}</Td>
                                <Td><Icon className="vss-clickable-icon" name="settings" resolution="low" onClick={() => props.manageBillingLine(row)} /></Td>
                            </Tr>
                        ))
                    } />
            }
        </>
    );
}

export default BillingLineTable;